import { getApiBase } from './apiBase.js';

const root = `${getApiBase()}/studentplayground/api/admin/agreements/versions/`;

async function request(path = '', options = {}, pdf = false) {
  const token = localStorage.getItem('jwtToken');
  if (!token) throw Object.assign(new Error('Ši funkcija nepasiekiama. Prisijunkite administratoriaus paskyra.'), { status: 401 });
  const response = await fetch(root + path, { ...options, cache: 'no-store', credentials: 'same-origin',
    referrerPolicy: 'no-referrer', headers: { Authorization: `Bearer ${token}`, ...options.headers } });
  if (!response.ok) {
    let data = {};
    try { data = await response.json(); } catch (_) { /* no provider/server text */ }
    const detail = typeof data.detail === 'string' ? data.detail
      : Object.values(data).filter(Array.isArray).flat().filter(value => typeof value === 'string').join(' ');
    throw Object.assign(new Error([401, 403].includes(response.status)
      ? 'Ši funkcija nepasiekiama. Reikalinga administratoriaus prieiga.'
      : detail || 'Užklausos įvykdyti nepavyko. Atnaujinkite sąrašą ir bandykite dar kartą.'), { status: response.status });
  }
  return pdf ? response.blob() : response.json();
}

export const listAdminAgreements = (q = '', page = 1) => request(`?${new URLSearchParams({ q, page })}`);
export const uploadAdminAgreement = form => request('', { method: 'POST', body: form });
export const searchAgreementStudents = (id, q, page = 1, signal, filter = 'students', dates = null) => request(`${id}/students/?${new URLSearchParams({ q, page, filter, ...(dates || {}) })}`, { signal });
export const getAgreementAssignments = (id, page = 1, signal) => request(`${id}/assignments/?${new URLSearchParams({ page })}`, { signal });

async function allPages(fetchPage, signal) {
  const rows = [];
  let count;
  for (let page = 1; page <= 1000; page++) {
    if (signal?.aborted) throw new DOMException('Aborted', 'AbortError');
    const result = await fetchPage(page);
    if (count === undefined) count = result.count;
    if (result.page !== page || result.count !== count || !Array.isArray(result.results)
        || (result.has_next && !result.results.length)) {
      throw new Error('Sąrašas pasikeitė. Atnaujinkite pasirinkimą ir bandykite dar kartą.');
    }
    rows.push(...result.results);
    if (!result.has_next) return rows;
  }
  throw new Error('Sąrašas per didelis. Susiaurinkite paiešką.');
}

export const getAllAgreementAssignments = (id, signal) => allPages(page => getAgreementAssignments(id, page, signal), signal);
export const getAllAgreementStudents = (id, q, filter, signal, dates = null) => allPages(page => searchAgreementStudents(id, q, page, signal, filter, dates), signal);
export const withdrawAgreementAssignment = (id, requirementId) => request(`${id}/assignments/${requirementId}/withdraw/`, {
  method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ confirm: true })
});
export const assignAgreementStudents = (id, ids) => request(`${id}/assign/`, {
  method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ student_ids: ids, confirm: true })
});

export async function previewAdminAgreement(id) {
  const blob = await request(`${id}/source/`, {}, true);
  const url = URL.createObjectURL(blob);
  try { window.open(url, '_blank', 'noopener,noreferrer'); }
  finally { setTimeout(() => URL.revokeObjectURL(url), 60000); }
}

export function agreementStatusLabel(status) {
  return ({ DRAFT: 'Juodraštis', ACTIVE: 'Paruoštas pasirašyti', RETIRED: 'Nebenaudojamas',
    assigned: 'Laukia pasirašymo', signing_in_progress: 'Pasirašoma',
    signed_storage_pending: 'Pasirašyta, tikrinama ir saugoma', finalization_failed: 'Reikalinga peržiūra',
    completed_stored: 'Pasirašyta', withdrawn: 'Priskyrimas atšauktas' })[status] || status;
}
